import { Body2, Display1 } from '@sainsburys-tech/fable'
import React from 'react'

interface IPluCodesProps {
  pluCodes: string[]
}

const QpigPluCode = ({ pluCodes }: IPluCodesProps) => {
  const getPluCode = () => {
    if (pluCodes === null || pluCodes === undefined) {
      return
    }

    if (pluCodes.length === 1) {
      return (
        <div
          data-testid='plu-code'
          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
        >
          <Display1>PLU Code:</Display1>
          <Body2>{pluCodes[0]}</Body2>
        </div>
      )
    } else {
      return pluCodes.map((pluCode: string, j) => {
        let separatorIndex = pluCode.indexOf(':')
        if (separatorIndex === -1) {
          separatorIndex = pluCode.indexOf('-')
        }
        const pluCodeName = pluCode.substring(0, separatorIndex)
        const pluCodeValue = pluCode.substring(
          separatorIndex + 1,
          pluCode.length,
        )
        return (
          <div
            data-testid={`plu-code-${j}`}
            key={j}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginTop: '0.5rem',
            }}
          >
            <Display1>PLU Code {pluCodeName}</Display1>:
            <Body2>{pluCodeValue}</Body2>
          </div>
        )
      })
    }
  }

  return <> {getPluCode()} </>
}

export default QpigPluCode
